import { Component, OnInit } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {services} from "../../services";

@Component({
  selector: 'app-apex-solo-placements',
  templateUrl: './apex-placements.component.html'
})
export class ApexPlacementsComponent implements OnInit {
  public service = 'placements';
  public availableServices = services['apex'].filter(service => service.service !== this.service);

  constructor(meta: Meta, title: Title) {
    title.setTitle('Apex Legends - Provisional Matches Boosting');
    meta.updateTag(
      // tslint:disable-next-line:max-line-length
      {
        name: 'description',
        content: 'Our Master and Apex boosters will ensure that you have a great start in the most critical Apex matches of the season.'
      },
    );
  }

  ngOnInit() {
  }

}
